import axios from "../../../util/axios";

const PREFIX_URI = "/wx/partner/wx";

/**
 * 客户/商机与企业微信外部联系人关联
 */
export default {
    /** 查询关联信息 */
    findByPartnerId: (partnerId) => axios.get({url: `${PREFIX_URI}/findByPartnerId`, data: {partnerId}}),
    /** 从企业微信获取客户资料（新增客户回填用） */
    fetchExternalContact: (externalUserId) => axios.get({url: `${PREFIX_URI}/fetchExternalContact`, data: {externalUserId}}),
    /** 关联企业微信客户 */
    bind: (partnerId, externalUserId) => axios.post({url: `${PREFIX_URI}/bind`, data: {partnerId, externalUserId}}),
    /** 解除关联 */
    unbind: (partnerId) => axios.del({url: `${PREFIX_URI}/unbind`, data: {partnerId}}),
};
